import React from "react";
import { Fade } from "react-awesome-reveal";
import Header2 from "parts/Header2";
import Discuss2 from "parts/Discuss2";
import Footer2 from "parts/Footer2";

export default function AboutUs2() {
  return (
    <>
      <Header2 />

      <section className="text-gray-800 py-16 px-4 md:px-10">
        {/* Title */}
        <div className="text-center mb-16">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl font-extrabold text-blue-800 mb-6 text-shadow-xl transform transition-all duration-500 ease-in-out">
              About Us
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed opacity-80">
              We are committed to delivering excellence through innovation,
              collaboration, and integrity.
            </p>
          </Fade>
        </div>

        {/* Backgrounds Card Full Width */}
        <div className="mb-20">
          <Fade direction="left" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 w-full mx-auto">
              <h2 className="text-3xl font-extrabold text-blue-800 mb-4 text-shadow-md">
                Backgrounds
              </h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Marine Logistics plc is a company established under Ethiopian
                law located at Bole sub city around Anbesa Grunge GB building
                3rd floor. Marine, “Your Reliable Logistics Solutions” is a
                clearing and forwarding company specializing in professional
                customs clearing, land transportation, Air import and export as
                well as sea import and export. Marine has a pool of resources
                capable of doing high volume of operation at a time, which is
                involved in clearing and leadership with financial institutions.
                We have excellent relationships with customers and carriers to
                facilitate business in the best way to exceed expectations.
              </p>
            </div>
          </Fade>
        </div>

        {/* Vision, Mission, Values, Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12">
          {/* Vision */}
          <Fade direction="left" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Our Vision
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Aspires to be the leading forwarding logistics company in
                Ethiopia by 2023.
              </p>
            </div>
          </Fade>

          {/* Mission */}
          <Fade direction="up" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Our Mission
              </h2>
              <p className="text-gray-700 leading-relaxed">
                - Providing an affordable and highly professional service to our
                customers.
              </p>
              <p className="text-gray-700 leading-relaxed">
                - Offering domestic and world-wide coverage service with
                multiple departures of FCL, LCL, break bulk, and project cargo.
              </p>
            </div>
          </Fade>

          {/* Services */}
          <Fade direction="right" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Core Services
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Cargo safety</li>
                <li>Customs clearance and transit</li>
                <li>Land transportation</li>
                <li>Air import and export</li>
                <li>Sea import and export</li>
                <li>Brokerage and consultancy services</li>
                <li>Warehousing, packing, and heavy lifting</li>
              </ul>
            </div>
          </Fade>

          {/* Services */}
          <Fade direction="right" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Competative solutions
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  We offer one-stop solutions and personalized services
                  according to client needs.
                </li>
                <li>Our rates are very competitive in the market.</li>
                <li>Timely delivery of services.</li>
                <li>
                  Value added services by providing the best logistic solution
                  to our clients.
                </li>
                <li>
                  SWe have professional team members who are well motivated and
                  always happy to assist.
                </li>
              </ul>
            </div>
          </Fade>

          <Fade direction="right" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Main Objective{" "}
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  To maximize satisfaction of customer’s needs in the industry.
                </li>
              </ul>
              <p className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Immediate Business Objectives at Marine:{" "}
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                  To engage in managing customer terminal, container clearing,
                  and forwarding.
                </li>
                <li>
                  To engage in a unimodal and multimodal transport operation.
                </li>
                <li>To engage in packing and moving services.</li>
              </ul>
            </div>
          </Fade>

          {/* Principles and Values */}
          <Fade direction="up" triggerOnce>
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8">
              <h2 className="text-2xl font-extrabold text-blue-700 mb-4 transform transition-all duration-500 hover:text-blue-900">
                Our Principles and Values
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Reliability</li>
                <li>Efficiency</li>
                <li>Productivity and Professionalism</li>
                <li>Readiness to Learn and Excel</li>
              </ul>
            </div>
          </Fade>
        </div>
      </section>

      <Discuss2 />
      <Footer2 />
    </>
  );
}
